import { motion } from "framer-motion";
import { ErrorIcon } from "./components/icons/ErrorIcon";
import { QualificationForm } from "./components/QualificationForm";
import { useLiff } from "./hooks/useLiff";

const LoadingSpinner = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center">
    <div className="relative">
      <div className="h-12 w-12 animate-spin rounded-full border-4 border-ocean-200 border-t-ocean-500" />
    </div>
    <p className="mt-4 font-medium text-ocean-600">読み込み中...</p>
  </div>
);

const ErrorDisplay = ({ message }: { message: string }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className="glass-card-solid mx-4 mt-8 rounded-2xl border-l-4 border-l-error-border bg-error-bg/80 p-5"
  >
    <div className="flex items-start gap-3">
      <ErrorIcon />
      <div>
        <h3 className="font-semibold text-error-text">エラーが発生しました</h3>
        <p className="mt-1 text-error-text/80 text-sm">{message}</p>
      </div>
    </div>
  </motion.div>
);

const WaveBackground = () => (
  <div className="pointer-events-none fixed inset-0 overflow-hidden" aria-hidden="true">
    <svg
      className="absolute bottom-0 left-0 h-48 w-[120%] text-ocean-500 opacity-[0.08]"
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
      role="presentation"
    >
      <path
        fill="currentColor"
        d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        className="animate-wave-slow"
      />
    </svg>
    <svg
      className="absolute bottom-0 left-0 h-40 w-[130%] text-teal-500 opacity-[0.06]"
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
      role="presentation"
    >
      <path
        fill="currentColor"
        d="M0,256L48,240C96,224,192,192,288,181.3C384,171,480,181,576,186.7C672,192,768,192,864,176C960,160,1056,128,1152,133.3C1248,139,1344,181,1392,202.7L1440,224L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
        className="animate-wave"
      />
    </svg>
  </div>
);

const PageLayout = ({ children }: { children: React.ReactNode }) => (
  <div className="relative mx-auto max-w-[420px] px-4 py-6">
    <WaveBackground />
    {children}
  </div>
);

export const App = () => {
  const { isReady, isLoggedIn, userId, error } = useLiff();

  if (error) {
    return (
      <PageLayout>
        <ErrorDisplay message={error.message} />
      </PageLayout>
    );
  }

  if (!isReady || !isLoggedIn || !userId) {
    return (
      <PageLayout>
        <LoadingSpinner />
      </PageLayout>
    );
  }

  return (
    <PageLayout>
      <QualificationForm userId={userId} />
    </PageLayout>
  );
};
